import React from 'react';
import '../radio-button/radio-button.scss';
import { useAppSelector } from '../../../store/hooks/StoreHooks';

interface CheckBoxProps {
  label: string;
  checked: boolean;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckBoxProps> = ({ label, checked, name, onChange }) => {

  const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id="checkbox"
        name={name}
        checked={checked}
        disabled={(customerEnabled && !customerCreated) || projectReadOnly}
        onChange={onChange}
        className={`form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${((customerEnabled && !customerCreated) || projectReadOnly) ? 'opacity-50 cursor-not-allowed' : ''
          }`}
      />
      <label htmlFor="checkbox" className="ml-[8px] text-[14px] text-neutral-25 font-semibold">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;